import { createComponent } from '@lit/react'
import * as React from 'react'

import Component from '../../components/icons/document/document-folder-open-line/document-folder-open-line.component.js'

const tagName = 'dap-ds-icon-folder-open-line'

/**
 * `dap-ds-icon-folder-open-line`
 * @summary An icon
 * @element dap-ds-icon-folder-open-line
 * @title - DocumentFolderOpenLine
 * @group icon
 * @icontype document
 *
 * @attribute {number} size - (optional) The width and height in pixels
 * @attribute {boolean} selected - (optional) Sets the icon color via the `fill` attribute
 * @attribute {string} accessibilityTitle - (optional) When using the icon standalone, make it meaningful for accessibility
 * @attribute {boolean} focusable - (optional) If `true` the icon can receive focus
 *
 * @csspart base - The main icon container.
 */
const reactWrapper = createComponent({
  tagName,
  elementClass: Component,
  react: React,
  events: {},
  displayName: 'DocumentFolderOpenLine',
})

export default reactWrapper
